import { Document } from '@/components/reader/Document';
import { getCurrentThread } from '@/store/reducers/UIState';
import { getReaderStateForThread } from '@/store/reducers/ReaderWidgetStore';
import { getShowableUrlWithoutChecking } from '@/api/ChatApi';
import { Header } from '@/components/reader/Header';
import { useAppSelector } from '@/store/hooks';

import { ContextProvider, ScrollContext } from '@allenai/pdf-components';
import { ErrorBoundary } from 'react-error-boundary';
import { useContext, useEffect } from 'react';

interface ReaderProps {}

export const Reader: React.FunctionComponent<ReaderProps> = () => {
  const currentThread = useAppSelector(getCurrentThread);
  const readerData = useAppSelector((state) =>
    getReaderStateForThread(state, currentThread?.id),
  );

  if (!readerData) {
    return null;
  }

  const { corpusId, highlights } = readerData;
  const pdfUrl = getShowableUrlWithoutChecking(corpusId);

  const { setScrollRoot } = useContext(ScrollContext);

  useEffect(() => {
    setScrollRoot(null);
  }, []);

  return (
    <ContextProvider>
      <ErrorBoundary fallback={<div>Something went wrong</div>}>
        <div>
          <Header />
          <Document
            key={pdfUrl}
            pdfUrl={pdfUrl}
            corpusId={corpusId}
            highlights={highlights}
          />
        </div>
      </ErrorBoundary>
    </ContextProvider>
  );
};
